
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: String,
    placeholder: String,
    error: String,
  },
});
